import { useEffect } from 'react';

import { useMapStoreContext } from '@/microfrontends/map/shared/context/mapStoreContext';

type AttachableLayer = YMaps.PinsLayer | YMaps.HotspotsLayer;

export function useAttachLayerToMap(attachableLayer: AttachableLayer): void {
  const { map } = useMapStoreContext();

  useEffect(() => {
    map.layers.add(attachableLayer.layer);

    return (): void => {
      map.layers.remove(attachableLayer.layer);
    };
  }, [map.layers, attachableLayer.layer]);
}
